import script from "./MainBox.vue?vue&type=script&setup=true&lang=js"
export * from "./MainBox.vue?vue&type=script&setup=true&lang=js"

import "./MainBox.vue?vue&type=style&index=0&id=9a48ecd4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a48ecd4"]])

export default __exports__